import { defineMessages } from 'react-intl'

export default defineMessages({
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  }
})
